/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ErrorRouteImport } from './routes/error'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTakeNewTaskRouteImport } from './routes/_authenticated/take-new-task'
import { Route as AuthenticatedTasksTaskIdRouteImport } from './routes/_authenticated/tasks/$taskId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorRoute = ErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTakeNewTaskRoute =
  AuthenticatedTakeNewTaskRouteImport.update({
    id: '/take-new-task',
    path: '/take-new-task',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTasksTaskIdRoute =
  AuthenticatedTasksTaskIdRouteImport.update({
    id: '/tasks/$taskId',
    path: '/tasks/$taskId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/take-new-task': typeof AuthenticatedTakeNewTaskRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
}
export interface FileRoutesByTo {
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/take-new-task': typeof AuthenticatedTakeNewTaskRoute
  '/': typeof AuthenticatedIndexRoute
  '/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/error': typeof ErrorRoute
  '/login': typeof LoginRoute
  '/_authenticated/take-new-task': typeof AuthenticatedTakeNewTaskRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/tasks/$taskId': typeof AuthenticatedTasksTaskIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/error' | '/login' | '/take-new-task' | '/tasks/$taskId'
  fileRoutesByTo: FileRoutesByTo
  to: '/error' | '/login' | '/take-new-task' | '/' | '/tasks/$taskId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/error'
    | '/login'
    | '/_authenticated/take-new-task'
    | '/_authenticated/'
    | '/_authenticated/tasks/$taskId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  ErrorRoute: typeof ErrorRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/error': {
      id: '/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof ErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/take-new-task': {
      id: '/_authenticated/take-new-task'
      path: '/take-new-task'
      fullPath: '/take-new-task'
      preLoaderRoute: typeof AuthenticatedTakeNewTaskRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tasks/$taskId': {
      id: '/_authenticated/tasks/$taskId'
      path: '/tasks/$taskId'
      fullPath: '/tasks/$taskId'
      preLoaderRoute: typeof AuthenticatedTasksTaskIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedTakeNewTaskRoute: typeof AuthenticatedTakeNewTaskRoute
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedTasksTaskIdRoute: typeof AuthenticatedTasksTaskIdRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedTakeNewTaskRoute: AuthenticatedTakeNewTaskRoute,
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedTasksTaskIdRoute: AuthenticatedTasksTaskIdRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  ErrorRoute: ErrorRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
